import { bb } from "$json";
/* horizontal-radio:
 *
 * Add tag 'horizontal' to 'smallish' radiogroup controls.
 *
 * 'Smallishness' here is a function of max_items and max_chars
 *
 * NOTE that this plugin performs an additive operation on the JSON
 * data object.
 *
 * Author: Niels Giesen
 * Copyright 2013, 2019 Berkeley Bridge
 *
 */
(function ($) {
  var max_chars = 10,
    max_items = 3,
    max_label;

  try {
    max_label = bb.conf.arbitrary["horizontal-radio"].max_label;
  } catch {
    // Swallow err
  } finally {
    if (!(typeof max_label === "number" && max_label === max_label))
      max_label = undefined;
  }

  $(function () {
    $(document).on("bb:preHandleData", function (event, data, status, req) {
      if (data && typeof data && data.groups) {
        $.map(data.groups, function (group) {
          group.controls.forEach(function (control, num) {
            if (control.controltype === "radio") {
              const len = control.value.length;
              if (len <= max_items) {
                let small = true;
                for (var i = 0; i < len; i++) {
                  if (control.value[i].option.length > max_chars) {
                    small = false;
                    return;
                  }
                }
                if (small && max_label) {
                  // Check label size
                  var label = group.controls[num + 1];
                  small = label.value.length <= max_label;
                }
                if (small) {
                  control.tags = control.tags || [];
                  control.tags.push("horizontal");
                  control._layout = "aside";
                }
              }
            }
          });
        });
      }
    });
  });
})(jQuery);
